import React from 'react'
import { NavLink } from 'react-router-dom'
import { SupportButton } from '@shared/ui/support-button'
import s from './style.module.scss'

export const NotFound = () => {
	return (
		<section className={s.wrapper}>
			<div className={s.glowTop} aria-hidden="true" />
			<div className={s.glowBottom} aria-hidden="true" />

			<div className={s.card}>
				<div className={s.badge}>Ошибка 404</div>

				<div className={s.visual} aria-hidden="true">
					<div className={s.vinyl}>
						<div className={s.vinylCenter}>404</div>
					</div>
					<div className={s.wave} />
					<span className={s.noteLeft}>♪</span>
					<span className={s.noteRight}>♫</span>
				</div>

				<div className={s.content}>
					<h1>Такой страницы мы ещё не нашли</h1>
					<p>Возможно, ссылка устарела или в адресе закралась ошибка</p>

					<div className={s.actions}>
						<NavLink className={s.primaryButton} to="/">
							Вернуться на главную
						</NavLink>
						<SupportButton
							label="Поддержка"
							theme="secondary"
							shape="pill"
							className={s.supportWrapper}
							buttonClassName={s.secondaryButton}
					/>
					</div>
				</div>
			</div>
		</section>
	)
}
